import { pick, type LayerStyle } from "./types";

// Boundaries only: district names, never ratings (fair-housing rule).
const BOUNDARY = "#8e6bd6";

const style: LayerStyle = {
  id: "isd-boundaries",
  minzoom: 8,
  maxzoom: 13,
  layers(source) {
    const base = { source, "source-layer": this.id, minzoom: this.minzoom };
    return [
      { id: `${this.id}:fill`, type: "fill", ...base, paint: { "fill-color": BOUNDARY, "fill-opacity": 0.04 } },
      { id: `${this.id}:line`, type: "line", ...base, paint: { "line-color": BOUNDARY, "line-width": 2, "line-dasharray": [3, 2] } },
    ];
  },
  legend: [{ label: "School district boundary", color: BOUNDARY }],
  describe: (p) =>
    pick(p, [
      ["NAME", "School district"],
      ["SCHOOLYEAR", "School year"],
    ]),
};

export default style;
